import { AxiosInstance } from 'axios';
import axiosClient from './axiosClientConfig';
import { HttpResponse } from 'interfaces/httpClient';
import { CategoryI } from 'interfaces';

/**
 * This class should hold all the routes to the endpoints that are
 * related to the categories handling inside the app.
 */

class CategoriesService {
	constructor(private categories: AxiosInstance) {}

	async getAll(): Promise<HttpResponse<CategoryI[]>> {
		return this.categories.get('/cases/categories');
	}
}

export const categoriesService = new CategoriesService(axiosClient);
